import axios from 'axios'
// import store from '@/store'
// @ts-ignore
import * as env from '../../env.json'

// const api = axios.create({
//  baseURL: env.API,
//  timeout: 100000,
//  withCredentials: true
// })

export const checkAccount = (seed: string) => {
  return axios.get(`${env.NODE}/addresses/balance/${seed}`)
}

export const getFaucetWithAddress = (address: string) => {
  return axios.get(`${env.BLOCKCHAIN_SERVICES}/api/v1/faucet/${address}`)
}

export const getRestoreUser = (restoreCode: string) => {
  return axios.get(`${env.MIDDLEWARE}/api/v1/utils/restoreUser/${restoreCode}`)
}

export const postRestoreUser = (restoreCode: string) => {
  return axios.post(`${env.MIDDLEWARE}/api/v1/utils/restoreUser/${restoreCode}`)
}

export const getRestoreUserDocument = (restoreCode: string) => {
  return axios.get(`${env.MIDDLEWARE}/api/v1/utils/restoreUserDocument/${restoreCode}`)
}

export const postBroadcastToBlockchain = (transaction: object) => {
  return axios.post(`${env.NODE}/transactions/broadcast`, transaction)
}

export const postRestoreToGetUserTransactions = (address, publicKey, addressNew) => {
  return axios.post(`${env.BLOCKCHAIN_SERVICES}/api/v1/restore`, { address, publicKey, addressNew })
}
